import { __assign, __awaiter, __generator, __read, __rest, __spreadArray } from "tslib";
import { handleError } from './handlers/handleError';
import { handleLocationChange } from './handlers/handleLocationChange';
import { handleMultilingual } from './handlers/handleMultilingual';
import { handleRTL } from './handlers/handleRTL';
import { SPECS } from '../../constants';
var createController = function (ControllerConstructor, controllerParams, extraParams) {
    try {
        if (extraParams) {
            return new ControllerConstructor(controllerParams, extraParams);
        }
        return new ControllerConstructor(controllerParams);
    }
    catch (e) {
        handleError(controllerParams)(e);
    }
};
export var controllerFactory = function (ControllerConstructor, _a) {
    if (_a === void 0) { _a = {}; }
    var extraParams = _a.extraParams, options = __rest(_a, ["extraParams"]);
    return function (controllerParams) {
        var _a;
        var siteStore = (_a = controllerParams === null || controllerParams === void 0 ? void 0 : controllerParams.appData) === null || _a === void 0 ? void 0 : _a.context.siteStore;
        var moveGetClientConfigToControllerFactory = siteStore.experiments.enabled(SPECS.MoveGetClientConfigToControllerFactory);
        var controller;
        if (!moveGetClientConfigToControllerFactory) {
            controller = createController(ControllerConstructor, controllerParams, extraParams);
        }
        return {
            pageReady: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var skipAppSettings, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 5, , 6]);
                                if (!moveGetClientConfigToControllerFactory) return [3 /*break*/, 2];
                                return [4 /*yield*/, siteStore.loadClientConfig()];
                            case 1:
                                _a.sent();
                                controller = createController(ControllerConstructor, controllerParams, extraParams);
                                _a.label = 2;
                            case 2:
                                handleRTL(controllerParams);
                                skipAppSettings = shouldSkipAppSettingsCall(options, controller, siteStore, controllerParams);
                                return [4 /*yield*/, Promise.all(__spreadArray(__spreadArray([], __read((skipAppSettings ? [] : [handleMultilingual(controllerParams, controller.getFreeTexts())])), false), [
                                        controller.init(),
                                    ], false))];
                            case 3:
                                _a.sent();
                                return [4 /*yield*/, handleLocationChange(controllerParams, function () { return void controller.load(); })()];
                            case 4:
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 5:
                                error_1 = _a.sent();
                                handleError(controllerParams)(error_1);
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            },
            exports: function () {
                return controller.exports();
            },
            updateConfig: function (_$w, updatedConfig) {
                var _a, _b, _c, _d;
                void ((_b = (_a = controller).onConfigUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, updatedConfig));
                return void ((_d = (_c = controller).onStyleUpdate) === null || _d === void 0 ? void 0 : _d.call(_c, updatedConfig.style.styleParams));
            },
            updateAppSettings: function (_$w, updates) {
                var _a, _b;
                return void ((_b = (_a = controller).onAppSettingsUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, updates));
            },
            onBeforeUnLoad: function () {
                var _a, _b;
                return (_b = (_a = controller).onBeforeUnLoad) === null || _b === void 0 ? void 0 : _b.call(_a);
            },
        };
    };
};
function shouldSkipAppSettingsCall(options, controller, siteStore, controllerParams) {
    var _a = __assign(__assign({}, options), controller.getOptionsOverrides()), shouldSkipMultilingual = _a.shouldSkipMultilingual, shouldCallAppSettingsOnlyWhenMultilingualIsNeeded = _a.shouldCallAppSettingsOnlyWhenMultilingualIsNeeded;
    var isMultilingualNotNeeded = function () {
        var multilingualFields = siteStore.getMultiLangFields();
        return (!controllerParams.controllerConfig.config.externalId ||
            !multilingualFields ||
            (multilingualFields === null || multilingualFields === void 0 ? void 0 : multilingualFields.isPrimaryLanguage));
    };
    return shouldSkipMultilingual || (shouldCallAppSettingsOnlyWhenMultilingualIsNeeded && isMultilingualNotNeeded());
}
//# sourceMappingURL=controllerFactory.js.map